module.exports = __webpack_public_path__ + "static/media/popup_img.7dca7f05.svg";